export default __webpack_public_path__ + "static/assets/1ea752cba084af62649dec5424a910c6.gif";